<template>
    <div id="app">
      <nav>
        <router-link to="/">首页</router-link> |
        <router-link to="/register">注册</router-link> |
        <router-link to="/login">登录</router-link> |
        <router-link to="/create-service">发布服务</router-link> |
        <router-link to="/services">服务列表</router-link> |
        <router-link to="/create-order">创建订单</router-link> |
        <router-link to="/orders">订单列表</router-link> |
        <router-link to="/order/status">更新订单状态</router-link>
      </nav>
      <router-view />
    </div>
  </template>
  
  <style>
  #app {
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
  }
    nav {
    padding: 30px;
  }
  nav a {
    font-weight: bold;
    color: #2c3e50;
  }
  nav a.router-link-exact-active {
    color: #42b983;
  }

  </style>